import { defineAdminIndexFiltersStorageController } from "../utils/admin_index_filters_storage"

const SKIP_FORM_MERGE_KEYS = new Set(["authenticity_token", "utf8", "commit", "button"])

function thingsIndexPathSuffix(pathname) {
  return /\/administration\/things$/.test(pathname || "")
}

function filtersParamsPresent(params) {
  return [...params.getAll("filters[]"), ...params.getAll("filters")].some(Boolean)
}

function mergeThingsIndexQueryWithDom(search) {
  const params = new URLSearchParams(search && search !== "?" ? search.replace(/^\?/, "") : "")

  function mergeMissingFromForm(formId) {
    const form = document.getElementById(formId)
    if (!form) return

    const fd = new FormData(form)

    for (const [key, val] of fd.entries()) {
      if (val === "" || val == null) continue
      if (SKIP_FORM_MERGE_KEYS.has(key)) continue

      if (key === "filters[]" || key === "filters") {
        if (!filtersParamsPresent(params)) params.append("filters[]", val)
        continue
      }

      const cur = params.get(key)
      if (cur === null || cur === "") params.set(key, val)
    }
  }

  mergeMissingFromForm("admin-things-index-search-form")
  mergeMissingFromForm("admin-things-index-filter-form")

  const input = document.getElementById("admin-things-index-search-input")
  const qDom = input?.value?.trim()
  if (qDom) params.set("q", qDom)

  const letterWrap = document.getElementById("admin-things-index-letter-filter")
  const swDom = letterWrap?.dataset?.selectedStartsWith?.trim()
  if (swDom && !(params.get("starts_with") || "").trim()) params.set("starts_with", swDom)

  const out = params.toString()
  return out === "" ? "" : `?${out}`
}

function hasPersistableFilterParams(searchParams) {
  if ((searchParams.get("q") || "").trim()) return true
  if ((searchParams.get("starts_with") || "").trim()) return true

  const filterVals = [...searchParams.getAll("filters[]"), ...searchParams.getAll("filters")].filter(Boolean)
  if (filterVals.length > 0) return true

  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith("tier_") && value === "1") return true
    if (["discarded", "featured", "unfeatured", "include_soft_deleted"].includes(key) && value === "1") return true
  }

  const limit = searchParams.get("limit")
  if (limit && limit !== "20") return true

  const page = searchParams.get("page")
  if (page && page !== "1") return true

  return false
}

export default defineAdminIndexFiltersStorageController({
  storageKey: "things-to-do-app:adminThingsIndexQuery",
  restoreInFlightKey: "things-to-do-app:adminThingsIndexRestoreInFlight",
  isIndexPath: thingsIndexPathSuffix,
  mergeQueryWithDom: mergeThingsIndexQueryWithDom,
  hasPersistableParams: hasPersistableFilterParams,
  defaultHref: "/administration/things",
  restoreVisitOptions: { frame: "admin-workspace" }
})
